import CheckIcon from '../../../app/components/checkbox/CheckIcon';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getColor } from '../../../utils/helper';

const StyledCheckIcon = ({ ...props }) => {
  return <CheckIconStyled {...props} />;
};

const CheckIconStyled = styled(CheckIcon)`
  path {
    fill: ${({ color, theme }) =>
      color ? getColor(color, theme) : theme.primary};
  }
`;

StyledCheckIcon.propTypes = {
  color: PropTypes.string,
};

export default StyledCheckIcon;
